import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Icon } from '@/components/common/Icon';
import { useDownloadImportTemplate } from '@/hooks/useDownloadImportTemplate';
import { showErrorNotification } from '@/utils/notifications';

export function TemplateDownloadCard() {
  const { t } = useTranslation('clientImport');
  const downloadMutation = useDownloadImportTemplate();

  function handleDownload() {
    downloadMutation.mutate(undefined, {
      onError: function notifyError() {
        showErrorNotification(t('template.downloadError'));
      },
    });
  }

  return (
    <Card padding="lg">
      <div className="flex items-start gap-4">
        <div className="w-11 h-11 rounded-xl bg-zoovpalelavender text-zooprimary flex items-center justify-center shrink-0">
          <Icon name="FileSpreadsheet" />
        </div>
        <div className="min-w-0 flex-1">
          <h2 className="text-base font-bold text-zooindigo">{t('template.title')}</h2>
          <p className="text-sm text-zoomuted mt-1">{t('template.description')}</p>
          <Button
            variant="secondary"
            size="small"
            className="mt-3 gap-1.5"
            isLoading={downloadMutation.isPending}
            onClick={handleDownload}
          >
            <Icon name="Download" />
            {t('template.download')}
          </Button>
        </div>
      </div>
    </Card>
  );
}
